<template>
  <div class="h-full">
    <!-- Sidebar for mobile -->
    <div v-if="isMobile">
      <q-btn
        flat
        dense
        round
        icon="menu"
        aria-label="Menu"
        class="absolute top-3 z-50"
        @click="toggleLeftDrawer"
      />

      <q-drawer
        v-model="leftDrawerOpen"
        show-if-above
        bordered
        :width="220"
        class="leftDrawer"
      >
        <SidebarComponent class="h-full" :mobile="isMobile" />
      </q-drawer>
    </div>

    <!-- Static sidebar for desktop -->
    <SidebarComponent v-else :mobile="isMobile" />
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import SidebarComponent from './SidebarComponent.vue';
import { useSidebar } from 'src/core/composables/layouts/sidebar/useSidebar';

const { isMobile } = useSidebar();
const leftDrawerOpen = ref(false);

function toggleLeftDrawer() {
  leftDrawerOpen.value = !leftDrawerOpen.value;
}
</script>
<style lang="scss" scoped>
.paddingTransition {
  transition: padding-left 1s;
}

.widthTransition {
  transition: width 1s;
}
</style>
